import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import DeleteButtonComponent from './component'

export const Delete = combine(
  withTableController({ id: 'athletes-table' }),
  withContext('appStore', StoreContext),
  withContext(
    'adminAthletesService',
    ServicesContext,
    ({ adminAthletesService }) => adminAthletesService
  ),
  withCallback(
    'onDeleteAthleteById',
    ({ adminAthletesService, table }, { value }) =>
      () => {
        adminAthletesService
          .removeAthleteById(value.id)
          .then(() => table.refresh())
      },
    ['value']
  )
)(DeleteButtonComponent)
